const VideoPlayer = {
	init() {
		const playerIcons = document.querySelectorAll('.play');
		if (playerIcons != null && playerIcons.length > 0) {
			playerIcons.forEach((playerIcon) => playerIcon.addEventListener('click', this.playVideo));
		}
	},

	playVideo(e) {
		if (e?.currentTarget?.parentNode && e?.currentTarget?.dataset?.video) {
			e.currentTarget.parentNode.innerHTML = `<iframe frameborder="0" allow="autoplay; fullscreen" allowfullscreen src="${e.currentTarget.dataset.video}?autoplay=1&title=0&byline=0&portrait=0"></iframe>`;
		}
	},
};

export { VideoPlayer as default };
